import { Component, OnInit, OnDestroy, OnChanges, SimpleChange, ViewChild, ViewChildren, QueryList, ElementRef, Input } from '@angular/core';
import { INgWidgetEvent, INgWidgetContainerConfig } from 'lib/ngx-draggable-widget/main';
import { Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';

import { Campaign, PlaylistContent } from '../../../cms/components/campaign/models/campaign';
import { Container, containerConfig } from '../../../cms/components/template/models/template';
import { PreviewAlgo } from '../../../cms/components/campaign/services/campaign-preview-algo';
import { MediaPreviewOnRegionComponent } from '../media-preview-on-region';
import { IonRangeSliderComponent } from "ng2-ion-range-slider";

@Component({
  selector: 'app-campaign-preview',
  templateUrl: './campaign-preview.component.html',
  styleUrls: ['./campaign-preview.component.scss']
})
export class CampaignPreviewShared implements OnInit, OnDestroy, OnChanges {

  public intervalObj: any;
  protected audioStopTime;
  protected audioStartTime;
  protected container: Container;
  protected finalDuration: number;
  protected containerBgDiv: any = {};
  protected audioPreview: PreviewAlgo;
  public isValidInterval: boolean = true;
  protected audioInterval: Subscription;
  public sourceAudioEnd: Subscription;
  public sourceAudioStart: Subscription;
  public audioReplayMode: boolean = false;
  protected previewState: string = 'LOADING';
  protected regionWidgetConfig: Array<INgWidgetEvent> = [];
  protected containerConfig: INgWidgetContainerConfig = _.clone(containerConfig);

  public minimumInterval: number = 0;
  public maximumInterval: number = 0;
  public previewInterval: any = { name: "Slider Interval", finish: undefined };
  public isNormalCampaign: boolean = true;
  @Input() campaignString;
  @Input() campaign: Campaign;
  @Input() previewSlide;
  private bgAudioPlayer: ElementRef;
  @ViewChild('sliderElement') sliderElement: IonRangeSliderComponent;
  @ViewChild('backgroundAudioPlayer') set content(content: ElementRef) {
    this.bgAudioPlayer = content;
  }
  @ViewChildren(MediaPreviewOnRegionComponent) regionsComp: QueryList<MediaPreviewOnRegionComponent>;

  constructor() {
    if (!this.container) {
      _.assignIn(this.containerConfig, { draggable: false, resizable: false });
      this.container = new Container();
    }
  }

  ngOnInit() { }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['campaign'] &&
      !_.isEqual(changes['campaign'].previousValue, changes['campaign'].currentValue) &&
      _.get(changes['campaign'].currentValue, 'aspectRatio.defaultWidthInPixel')
    ) {
      this.containerBgDiv = {}
      this.renderContents(changes['campaign'].currentValue);
    }
  }

  renderContents = function (campaign: Campaign) {
    if (campaign.audioEndBasedOnLayoutDurationInSeconds) {
      this.audioStopTime = campaign.audioEndBasedOnLayoutDurationInSeconds;
    }
    if (campaign.audioStartBasedOnLayoutDurationInSeconds) {
      this.audioStartTime = campaign.audioStartBasedOnLayoutDurationInSeconds;
    }
    this.container.setActualHightAndWidth(
      campaign.aspectRatio.defaultWidthInPixel,
      campaign.aspectRatio.defaultHeightInPixel
    );
    this.finalDuration = this.maximumInterval = parseInt('' + campaign.totalDurationOfCampaignInSeconds);
    if (campaign['transparencyInPercentage'] != null) {
      this.setContainerBgDiv({
        opacity: campaign['transparencyInPercentage'] / 100,
        backgroundColor: campaign['backgroundColor'] || '#000000'
      });
    }
    this.setRegionWidgetConfig(campaign);
    if (campaign.backgroundImageContent && campaign.backgroundImageContent.mediaUrl) {
      this.setContainerBgDiv({ backgroundImageUrl: campaign.backgroundImageContent.mediaUrl });
    }
    if (campaign.audios && campaign.audios.length > 0) {
      this.playParentAudioOfRegion(campaign.audios)
    }
  }

  playParentAudioOfRegion = function (audios: any) {
    if (this.audioInterval && !this.audioInterval.closed) {
      this.audioInterval.unsubscribe();
    }
    this.audioPreview = new PreviewAlgo(audios, this.finalDuration, 'defaultDurationInSeconds', this.intervalObj);
    this.audioInterval = this.audioPreview.start()
      .subscribe((res: any) => {
        let content: PlaylistContent = res.content,
          durationPassInSecond: number = res.durationPassInSecond;
        if (!_.isEmpty(content)) {
          this.muteTrimAudio(content, durationPassInSecond);
          this.playAudio(content, durationPassInSecond);
        }
      }, (err) => {
        console.error('ParentAudioError: ', err);
      }, () => {
        this.stopAudio();
        if (this.inactiveTimer) {
          this.inactiveTimer.unsubscribe();
        }
        //console.log('Completed > audio >', this.audioPreview.debugLog);
      });

    //for Audio repeat
    let totalaudioDuration;
    totalaudioDuration = 0;
    _.forEach(audios, (data) => {
      totalaudioDuration += data.defaultDurationInSeconds;
    });
    totalaudioDuration = (totalaudioDuration + +1);
    this.replayAudioIfCampaignLengthGreater(totalaudioDuration)
  }

  setContainerBgDiv = function (option) {
    if (option.opacity !== undefined) {
      this.containerBgDiv.opacity = (!_.isEmpty('' + option.opacity)) ? (1 - option.opacity) : null;
    }
    if (option.backgroundColor !== undefined) {
      this.containerBgDiv['background-color'] = (!_.isEmpty(option.backgroundColor)) ? option.backgroundColor : '#000000';
    }
    if (option.backgroundImageUrl !== undefined) {
      this.containerBgDiv['background-image'] = (!_.isEmpty(option.backgroundImageUrl)) ? 'url(' + option.backgroundImageUrl + ')' : null;
    }
  }

  setRegionWidgetConfig = (campaign: Campaign) => {
    this.regionWidgetConfig = [];
    if (campaign && campaign.regions && campaign.regions.length > 0) {
      campaign.regions.map((_region) => {
        this.regionWidgetConfig.push(this.container.getWidgetConfigByRegionValue(_region));
      });
    }
    this.isNormalCampaign = (this.campaign["layoutType"] == "NORMAL") ? true : false;
  }

  muteTrimAudio = function (audio?: any, durationPassInSecond?: any) {
    if (this.intervalObj !== undefined) {
      if (this.sourceAudioEnd && !this.sourceAudioEnd.closed)
        this.sourceAudioEnd.unsubscribe();

      if (this.sourceAudioStart && !this.sourceAudioStart.closed)
        this.sourceAudioStart.unsubscribe();

      this.audioStartTime = this.audioStartTime - this.intervalObj.val;
      this.audioStartTime = (this.audioStartTime > 0) ? this.audioStartTime : 0;
      this.audioStopTime = this.audioStopTime - this.intervalObj.val;
      this.audioStopTime = (this.audioStopTime > 0) ? this.audioStopTime : 0;
    }
    else {
      if ((durationPassInSecond - audio.defaultDurationInSeconds) > this.audioStartTime) {
        this.audioStartTime = this.audioStopTime = -1;
      }
    }
    if (this.audioStartTime >= 0) {
      this.bgAudioPlayer.nativeElement.muted = true;
      this.sourceAudioStart = Observable
        .interval(1000)
        .take((this.audioStartTime + 1))
        .subscribe((i) => {
          if (i === this.audioStartTime) {
            this.bgAudioPlayer.nativeElement.muted = false;
          }
        });
    }
    if (this.audioStopTime >= 0) {
      this.sourceAudioEnd = Observable
        .interval(1000)
        .take((this.audioStopTime + 1))
        .subscribe((j) => {
          if (j === this.audioStopTime) {
            this.bgAudioPlayer.nativeElement.muted = true;
          }
        });
    }
  }

  playAudio = function (content: PlaylistContent, durationPassInSecond: number) {
    let setAudioInterval: number = 0;
    this.bgAudioPlayer.nativeElement.src = content.mediaUrl;
    if (this.intervalObj !== undefined && this.isValidInterval) {
      this.isValidInterval = false;
      if (content.defaultDurationInSeconds == durationPassInSecond) {
        setAudioInterval = this.intervalObj.val
      }
      else {
        setAudioInterval = durationPassInSecond - this.intervalObj.val;
      }
      // setAudioInterval = this.calculateCampaignAudioDurations(this.campaign.audios);
      // console.log("VV: ", setAudioInterval);
      this.bgAudioPlayer.nativeElement.currentTime = setAudioInterval;
    }
    this.bgAudioPlayer.nativeElement.play();


  }

  stopAudio = function () {
    if (this.bgAudioPlayer) {
      this.bgAudioPlayer.nativeElement.pause();
    }
  }

  replay = function (audios?: any, from: number = 0) {
    this.ngOnDestroy();
    this.renderContents(this.campaign);
    this.sliderElement.update({ from: from });
    this.regionsComp.forEach(regionCamp => {
      regionCamp.playMediaInRegion();
    });
  }

  previewOnInterval = function (intervalObj?: any) {
    this.ngOnDestroy();
    this.isValidInterval = true;
    this.intervalObj = intervalObj;
    this.renderContents(this.campaign);
    this.regionsComp.forEach(regionCamp => {
      regionCamp.playMediaInRegion(intervalObj);
    });
  }

  onFinishPreviewInterval = function (slider, event) {
    if (event) {
      slider.finish = event;
      let intervalObj: any = {
        "id": 1, "name": slider.finish.from, "val": slider.finish.from
      };
      this.previewOnInterval(intervalObj);
    }
  }

  resetPlaybackSlider(from) {
    this.stopAudio();
    this.sliderElement.update({ from: from });
  }

  // Faild on repeat.
  calculateCampaignAudioDurations = function (audios?: any) {
    let _index: number = 0,
      calculatedVal: number = 0,
      durationPassInSecond: number = 0,
      currentDurationInSecond: number = 0,
      selectedInterval: number = (this.intervalObj.val != "undefined") ? this.intervalObj.val : 0;

    _.forEach(audios, (audio) => {
      currentDurationInSecond = audio.defaultDurationInSeconds;
      if (
        selectedInterval > durationPassInSecond
      ) {
        let videoInt = (selectedInterval + _index) - (durationPassInSecond);
        calculatedVal = (videoInt > 0) ? videoInt : 0;
      }
      _index++;
      durationPassInSecond = durationPassInSecond + currentDurationInSecond;
    });
    if (this.finalDuration > durationPassInSecond && calculatedVal == 0) {
      // loop again..      
    }
    return calculatedVal;
  }

  //check for audio repeat
  public replayAudioIfCampaignLengthGreater = function (totalaudioDuration) {
    // const interval = 1000;
    // const duration = totalaudioDuration
    // this.inactiveTimer = Observable.timer(0, interval)
    //   .take(duration)
    //   .subscribe(()=>{},
    //     err => { },
    //     () => {
    //       this.audioReplayMode =true;
    //       this.stopAudio();
    //       this.playParentAudioOfRegion(this.campaign.audios)
    //     });
  }

  ngOnDestroy(from: number = 0) {
    this.stopAudio();
    this.intervalObj = { id: 1, name: 0, val: 0 };
    if (this.audioInterval && !this.audioInterval.closed)
      this.audioInterval.unsubscribe();

    if (this.sourceAudioEnd && !this.sourceAudioEnd.closed)
      this.sourceAudioEnd.unsubscribe();

    if (this.sourceAudioStart && !this.sourceAudioStart.closed)
      this.sourceAudioStart.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/campaign-preview/campaign-preview.component.ts